import { returnPath } from "~/features/common/utils/navigation/returnPath";

export const getIdPath = returnPath("/admin/teams/:id");
export const getIndexPath = returnPath("/admin/teams");
